import { useMultisportPartnersStore } from '@/domains/partners/multisport/store/useMultiSportPartnersStore'

export const useMultiSportPartner = () => {
  const { getFieldValue, $v } = useMultisportPartnersStore()

  const chunksValidationOne = async () => ([
    await $v.value.firstName.$validate(),
    await $v.value.companyRole.$validate(),
    await $v.value.lastName.$validate(),
    await $v.value.email.$validate(),
    await $v.value.phonePrefix.$validate(),
    await $v.value.phone.$validate(),
  ])

  const chunksValidationTwo = async () => ([
    await $v.value.district.$validate(),
    await $v.value.nipNumber.$validate(),
    await $v.value.companyName.$validate(),
    await $v.value.street.$validate(),
    await $v.value.buildingNumber.$validate(),
    await $v.value.city.$validate(),
    await $v.value.zipCode.$validate(),
    await $v.value.workedWithBS.$validate(),
  ])

  const chunksValidationThree = async () => ([
    await $v.value.objectName.$validate(),
    await $v.value.objectArea.$validate(),
    await $v.value.objectDistrict.$validate(),
    await $v.value.objectStreet.$validate(),
    await $v.value.objectCity.$validate(),
    await $v.value.objectBuildingNumber.$validate(),
    await $v.value.objectApartmentNumber.$validate(),
    await $v.value.objectPhone.$validate(),
    await $v.value.objectPrefixPhone.$validate(),
    await $v.value.objectZipCode.$validate(),
    await $v.value.objectWebiste.$validate(),
    await $v.value.objectCategory.$validate(),
    await $v.value.objectOtherCategory.$validate(),
    await $v.value.objectHasOC.$validate(),
    await $v.value.objectHasPermits.$validate(),
    await $v.value.objectHasSafetyEquipment.$validate(),
    await $v.value.objectHasReception.$validate(),
    await $v.value.objectIsAutonomous.$validate(),
    await $v.value.objectAcceptTerms.$validate(),
  ])

  const isStepValid = async (index: number): Promise<boolean> => {
    let valid = false
    
    switch (index) {
      // boolean object constructor is truthy
      case 1: valid = (await chunksValidationOne()).every(Boolean); break
      case 2: valid = (await chunksValidationTwo()).every(Boolean); break
      case 3: valid = (await chunksValidationThree()).every(Boolean); break
    }

    return valid
  }

  return {
    isStepValid,
    getFieldValue,
  }
}
